import * as Html from "../../util/Html.ts";
import * as modal from "../../util/modal.ts";
import ApiServer from "../../ApiServer.js";
import * as libLocation from "../../lib/location.ts";
import * as FwDatas from "../../FwDatas.ts";
import * as Locale from "../../util/Locale.js";

import MAIN_MODAL from "../../list/modal_listcategories.mustache";
import TPL_ITEM from "../../list/modal_listcategories_item.mustache";
import { registerDragStart } from "../../lib/FileUtils.ts";
import $ from "../../$.js";

let list,theModal,preparedPut;

Html.register({
  tasklistcategorymanage:function(){
    var 
      metaId = this.metaId(),
      locale = Locale.get().substring(0,2);
      
    list = FwDatas.get(metaId);
    var categories = list.getCategories(true);
    
    preparedPut = ApiServer.taskcategoryput.prepare({
      tasklistId:metaId,
      locale:locale,
      taskListType:list.taskListType,
      filterTasklistId:list.taskListType==='OTHER'?metaId:undefined
    });
      
    theModal = modal.openModal(MAIN_MODAL,{categories:categories,isEmpty:categories.length===0});
    
    function update(){
      let 
        catNode = $(this).parents(".listcategoryedit"),
        metaId = catNode.metaId(),
        emoji = catNode.find('input[name=emoji]').val(),
        name = catNode.find('input[name=name]').val();

      if(metaId){
        let catFromCache = FwDatas.get(metaId)
        catFromCache.name = name;
        catFromCache.emoji = emoji;
        
        theModal.modified = true;
        preparedPut({metaId:metaId,name:name,emoji:emoji||'🏷️'},function(){
          catNode.find('input[name=name]').removeClass('fw-form-invalid-control')
        },function(){
          catNode.find('input[name=name]').addClass('fw-form-invalid-control')
        })
        
      }else if(name){
        theModal.modified = true;
        preparedPut({name:name,emoji:emoji||'🏷️'},function(cat){
          Html.replaceWith(catNode,TPL_ITEM,cat)
          displayEmpty()
        });
      }else if(emoji){
        //just emoji we wait for a name
      }else{
        catNode.remove()
      }
    }
    theModal.delegate('input','change',update)
    theModal.modified = false;
    theModal.onClose=function(){
      if(theModal.modified){
        libLocation.refresh();
      }
    }
  },
  listcatclick:function(){
    var input = this.parent().find('input');
    input.focus();
    setTimeout(function(){input.select()},50)
  },
  listcatdelete:function(){
    let 
      catNode = $(this).parents(".listcategoryedit"),
      metaId = catNode.metaId();
    if(metaId){
      modal.confirmDelete({title:"mp.categoriesaskdelete",message:"",yes:"actions.delete"},()=>{
        theModal.modified = true;
        ApiServer.taskcategorydelete(metaId,function(){
          catNode.fadeOut(300, function() {
            catNode.remove();
            setTimeout(displayEmpty(),100)
          });
        })
      });  
    }else{
      catNode.fadeOut(300, function() {
        catNode.remove();
        setTimeout(displayEmpty(),100)
      });
    }  
    
  },
  listcataddfield:function(){
    var 
      catNode = Html.setHtmlAtEnd(this.prev(),TPL_ITEM,{emoji:'🏷️',rights:{canUpdate:true,canDelete:true}});
    catNode.find('input[name=name]').focus();
  }
})
function displayEmpty(){
  theModal.find('.empty').toggle(theModal.find('.listcategoryeditdroppable .listcategoryedit').length===0)
}


registerDragStart(".listcategoryedit",async function(ev,dropPromiseBuilder){
  var  
    movingNode = $(this),
    potentialDrop = document.querySelectorAll('.listcategoryedit'),
    dropEvent = await dropPromiseBuilder(this,potentialDrop),
    dropNode = $(dropEvent.target).metaIdNode();

  var nodeBefore = null;
  if(dropNode.offset().top + dropNode.height()/2>dropEvent.clientY){
    nodeBefore = dropNode.prev();
    movingNode.detach().insertBefore(dropNode)
  }else{
    nodeBefore = dropNode;
    movingNode.detach().insertAfter(dropNode)
  }
  let catFromCache = FwDatas.get(movingNode.metaId())
  theModal.modified = true;
  preparedPut(new ApiServer.types.TaskCategoryInputBean({metaId:catFromCache.metaId}),nodeBefore.metaId()||"$empty",function(cat){
    Html.replaceWith(movingNode,TPL_ITEM,cat);
  })

})


$(document).on('focus','.listcategoryedit input',function(ev){
  let node = $(this).metaIdNode();
  node.data('original',ev.target.value)
  node.find('[data-fw-onclick="listcatclick"]').hide();
  node.find('[data-fw-onclick="listcatdelete"]').show();
})
$(document).on('blur','.listcategoryedit input',function(ev){
  setTimeout(()=>{
    let node = $(this).metaIdNode();
    node.find('[data-fw-onclick="listcatclick"]').show();
    node.find('[data-fw-onclick="listcatdelete"]').hide();
  },50)
})

$(document).on('keypress','.listcategoryedit input',function(ev){
  if(ev.keyCode===13 || ev.keyCode===10){
    ev.preventDefault();
    $(this).blur()
  }
})